import { ChangeDetectionStrategy, Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IProjectDiscussionCommentContent } from '@shared/components/project-discussion/service/project-discussion.service.types';
import { IProject } from '@shared/services/project.service.types';
import { ProjectDiscussionChatHeaderComponent } from '../project-discussion-chat-header/project-discussion-chat-header.component';
import { ProjectDiscussionChatControlsComponent } from '../project-discussion-chat-controls/project-discussion-chat-controls.component';

@Component({
  selector: 'app-project-discussion-chat-reply',
  templateUrl: './project-discussion-chat-reply.component.html',
  styleUrls: ['./project-discussion-chat-reply.component.scss'],
  imports: [ProjectDiscussionChatHeaderComponent, ProjectDiscussionChatControlsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectDiscussionChatReplyComponent {
  @Input() project: IProject;
  @Input() reply: IProjectDiscussionCommentContent;
}
